// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"297e9e6c","193":"8d836632","208":"58d78a53","257":"f26c7837","289":"c2fcd9bc","395":"f1d5cb7a","427":"d68d2058","432":"d5dc0525","443":"b7a15164","450":"0953c3e2","600":"c14983b7","674":"93d4ecd4"}[chunkId] + ".chunk.js";
};